export class ReconsRequestParams {
  from_date?: Date;
  to_date?: Date;
  code?: string | null = null;
  status?: string | null = null;
  filter: string = '';
  pageNo: number = 1;
  rowPerPage: number = 10;
}

export class ReconsSearchParams {
  fromDate?: Date;
  toDate?: Date;
  code?: string | null = null;
  status?: string | null = null;
  filter: string = '';
  pageNo: number = 1;
  rowPerPage: number = 10;
}


export class ReconsResp {
  code: number = 0;
  message: string = '';
  data: ReconDataResp[] = [];
  totalPage: number = 0;
  currentPage: number = 1;
}

export class ReconDataResp {
  id: string = '';
  code: string = '';
  bill_id: string = '';
  pdam_name: string = '';
  ref_id: string = '';
  period: string = '';
  amount: number = 0;
  status: string = '';
  trx_date: string = '';
  // Channel identifier returned by the PDAM upstream (KODE_BANK / bank).
  // Populated since switching_common v0.1.39 — older rows pulled before
  // that ship date carry an empty string.
  // Known values:
  //   "BRIN"/"BNIN"/"CENA"/"BCA"/"BMRI"   → VA banks
  //   "40004"  → Kiosbank channel (labeled Shopee in PDAM file)
  //   "40003"  → MCOMPPOB channel (labeled Mitracom)
  //   other numeric codes / "-"            → unknown / other
  bank_code?: string = '';
}

// Body for POST /recons/sync
export interface ReconSyncReq {
  code: string;
  date: string; // YYYY-MM-DD (Asia/Jakarta)
}

// Response shape for both POST /recons/sync (initial) and
// GET /recons/sync/:job_id (polling).
export interface ReconSyncStatus {
  job_id: string;
  code: string;
  date: string;
  status: 'queued' | 'running' | 'completed' | 'failed';
  started_at: string;
  finished_at?: string;
  rows_deleted: number;
  rows_inserted: number;
  error_message?: string;
}

export interface ReconSyncResp {
  code: number;
  message: string;
  data: ReconSyncStatus;
}

// ─── Match (button "Match dengan Transaksi") ────────────────────────────

export interface ReconMatchReq {
  code: string;
  date: string; // YYYY-MM-DD (Asia/Jakarta)
}

export interface ReconMatchResult {
  code: string;
  date: string;
  matched_recon_rows: number;     // total (local + apidash)
  matched_local: number;          // stage 1: paired with this app's transactions
  matched_apidash: number;        // stage 2: paired with sister-system apidash
  touched_transactions: number;
  unmatched_success_tx: number;
  apidash_fetched: number;        // -1 if fetch errored
  apidash_error?: string;
  ran_at: string;
}

export interface ReconMatchResp {
  code: number;
  message: string;
  data: ReconMatchResult;
}

// ─── Unmatched Transactions tab ────────────────────────────────────────

export interface ReconUnmatchedRow {
  transaction_detail_id: string;
  transaction_id: string;
  tx_id: string;
  bill_id: string;
  period: string;
  bill_amount: number;
  transaction_amount: number;
  provider_code: string;
  merchant_code: string;
  created_at: string;
  customer_name: string;
}

export interface ReconUnmatchedListResp {
  code: number;
  message: string;
  data: {
    code: string;
    date: string;
    total: number;
    page_no: number;
    row_per_page: number;
    data: ReconUnmatchedRow[];
  };
}

// ─── Bank Mandiri report (VA + PPOB Excel) ─────────────────────────────

// One row in either the VA or PPOB list. FE reconstructs the
// "YYYYMMDD_<bill_id>" Ref_id column and computes Fee Bank Mandiri
// client-side (PPOB=125 flat; VA=250 + max(0, N-9)).
export interface BankMandiriReportRow {
  billing_id: string;
  recon_ref_id: string;
  amount: number;
  bank_code: string;
  tx_id: string;
  trx_date: string;
  period: string;
}

// Response for GET /recons/bank-mandiri-report?code=...&date=...
// all_matched gates the two FE download buttons (disabled while
// pending_rows > 0).
export interface BankMandiriReportData {
  code: string;
  date: string;
  all_matched: boolean;
  pending_rows: number;
  va: BankMandiriReportRow[];
  ppob: BankMandiriReportRow[];
}

export interface BankMandiriReportResp {
  code: number;
  message: string;
  data: BankMandiriReportData;
}
